import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "./jsx.js";
import { PageWithItems } from "./PageWithItems.js";
import { PageWithMarkdown } from "./PageWithMarkdown.js";
import { createTitle } from "./title.js";
import { history } from "./History.js";
function getPageProps(input) {
    if ("payload" in input) {
        return JSON.parse(input.payload);
    }
    return input.props;
}
function isPageWithListProps(props) {
    return props && props.items && Array.isArray(props.items);
}
function isPageWithMarkdownProps(props) {
    return props && props.bodyMarkdown;
}
function usePageProps(initial) {
    const [props, updateProps] = useState(initial);
    const [scrollTop, updateScrollTop] = useState(false);
    const handlePopState = useCallback((e) => {
        const state = e.detail?.state || e.state;
        updateProps({ payload: state });
        updateScrollTop(e.detail ? true : false);
    }, [0]);
    useEffect(() => {
        return history().onPushState(handlePopState);
    }, [0]);
    return { pageProps: getPageProps(props), scrollTop };
}
export function PageRenderer(props) {
    const { pageProps, scrollTop } = usePageProps(props);
    useEffect(() => {
        document.title = createTitle(pageProps.title);
        if (scrollTop) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [pageProps.title, scrollTop]);
    if (isPageWithMarkdownProps(pageProps)) {
        return _jsx(PageWithMarkdown, { ...pageProps });
    }
    if (isPageWithListProps(pageProps)) {
        return _jsx(PageWithItems, { ...pageProps });
    }
    return null;
}
